import { Component, EventEmitter, Output } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { EventLoggerService } from '@services/event-logger-service';
import { AppConfig } from 'client/app/app.config';
import { Router } from '@angular/router';

@Component({
  selector: 'hair-thinning-banner',
  templateUrl: './hair-thinning.component.html',
  standalone: false,
})
export class HairThinningComponentComponent {
  user: any;
  showBanner: boolean = false;
  regimens: any;
  activeFaceRegimen: any;
  activeHairRegimen: any;
  constructor(
    private eventLogger: EventLoggerService,
    private conn: ConnectionService,
    public appConfig: AppConfig,
    private router: Router,
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.user = this.conn.getActingUser();
    if (this.user.get('Gender') === 'Male') return;
    const newMom = ['PREGNANT', 'NEW_MOM'];
    const regimens = await this.conn.fetchRegimens(null, true);
    this.regimens = regimens.filter((regimen: any): any => !regimen.expired && regimen.active);
    this.activeFaceRegimen = this.regimens.find((regimen: any):any => regimen.delivered && regimen.class
    === this.appConfig.Shared.Regimen.Class.FACE);
    this.activeHairRegimen = this.regimens.find((regimen: any):any => regimen.delivered && regimen.class
    === this.appConfig.Shared.Regimen.Class.HAIR);

    if (this.activeFaceRegimen
      && !this.activeHairRegimen
      && newMom.some((tag:any): any => this.user.get('marketingTags').includes(tag))
    ) {
      this.showBanner = true;
    }
  }

  handleClick(): void {
    this.navigateTo('/user?tab=regimen&class=HAIR');
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'homepage-hair-thinning-banner' }));
  }

  navigateTo(url: string = ''): void {
    if (!url) return;
    const queryParams: Record<string, any> = {};
    const [URL, qParamString]: string[] = url.split('?');
    if (qParamString) {
      qParamString.split('&').forEach((each: string): void => {
        const [key, value]: string[] = each.split('=');
        queryParams[key] = value;
      });
    }
    this.router.navigate([URL], { queryParams });
  }
}
